import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { useAccount, useSignMessage } from 'wagmi';
import toast, { Toaster } from 'react-hot-toast';

import { useWeb3Auth } from './Web3AuthContext';

export const plural = (count) => count >= 2 ? 's' : '';

export function Home() {
  const web3AuthInstance = useWeb3Auth();

  const { address, isConnected } = useAccount();
  const [userDetails, setUserDetails] = useState();
  const [privateKey, setPrivateKey] = useState(false);

  const [currentAction, setCurrentAction] = useState(null);
  const [isMessageReadyForSign, setIsMessageReadyForSign] = useState(false);
  const [userWalletUpdated, setUserWalletUpdated] = useState(false);

  console.log(web3AuthInstance);

  const { isLoading: signIsLoading, signMessage } = useSignMessage({
    mutation: {
      onSuccess(signData) {
        if (currentAction === 'add') {
          updateWallet(userDetails?.userID, { address, isExternal: web3AuthInstance.status === "connected" ? false : true }, signData, 'add');
        } else if (currentAction === 'remove') {
          updateWallet(userDetails?.userID, { address }, signData, 'remove');
        } else if (currentAction === 'makePrimary') {
          updateWallet(userDetails?.userID, { address }, signData, 'makePrimary');
        }
      },
    }
  });

  useEffect(() => {
    async function fetchDetails() {
      if (!address) return;

      try {
        const response = await fetch('https://wallet.cryptocademia.com/userInfos');
        const details = await response.json();

        setUserDetails(details);
      } catch (err) {
        console.log(err);
      }
    }

    fetchDetails();
  }, [address, userWalletUpdated]);

  async function updateWallet(userID, walletData, userSign, action) {
    if (!userID || !walletData || !userSign) return;

    try {
      const response = await fetch('https://wallet.cryptocademia.com/userUpdate', {
        method: 'POST',
        body: JSON.stringify({ userID, walletData, userSign, action }),
      });

      const request = await response.json();
      if (request.success) {
        setUserWalletUpdated(Date.now());
        toast.success(() => (<div>{request.success}</div>), { style: { wordBreak: 'break-word' } });
      } else {
        toast.error(() => (<div>Erreur : {request.error}</div>), { style: { wordBreak: 'break-word' } });
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    setPrivateKey(null);
  }, [address]);

  const getPrivateKey = async () => {
    if (!web3AuthInstance.commonJRPCProvider) { return; }
    if (window.confirm('Please note, the private key must not be shared, check that no one other than you will be able to see it. Reveal it?')) {
      const pKey = await web3AuthInstance.commonJRPCProvider.request({ method: 'eth_private_key' });
      setPrivateKey(pKey);
    }
  };

  const handleWalletAddition = () => {
    if (!userDetails || userDetails?.wallets?.some(w => w.address === address)) return;
    setCurrentAction('add');
    signMessage({
      message: `${userDetails?.username} - Add wallet => ${address}`
    });
  };

  const handleWalletRemoval = walletAddress => {
    setCurrentAction('remove');
    signMessage({
      message: `${userDetails?.username} - Remove wallet => ${address}`
    });
  };

  const handleWalletMakePrimary = walletAddress => {
    setCurrentAction('makePrimary');
    signMessage({
      message: `${userDetails?.username} - Make primary wallet => ${address}`
    });
  };

  useEffect(() => {
    if (isMessageReadyForSign) {
      signMessage();
      setIsMessageReadyForSign(false);
    }
  }, [isMessageReadyForSign, signMessage]);

  const isNotPrimary = userDetails?.wallets?.some(w => w.address === address) && userDetails.wallets[0]?.address !== address;

  return (
    <>
      {isConnected && (
        <Container className="col-xl-10 col-xxl-8 px-4">
          <Row className="py-2">
            <Col md={7} className="mx-auto">
              {!userDetails && <div className="my-4">Loading...</div>}

              {userDetails && userDetails.username && (
                <>
                  <div className="my-4">
                    <p>👋 <b>{userDetails.username}</b></p>

                    {userDetails.wallets && userDetails.wallets.length > 0 ? (<>

                      {userDetails.wallets.length >= 2 ? (<p>Here are the wallets currently binded to your account:</p>) : (<p>Here is the wallet currently binded to your account:</p>)}

                      <ul className="mt-2">
                        {userDetails.wallets.map((wallet, index) => (
                          <li key={index}><span className="address">{wallet.address}</span> ({wallet.isExternal ? 'External' : 'Generated'})</li>
                        ))}
                      </ul>
                    </>) : <p>No wallet registered on your <b>Cryptocademia</b> account.</p>}
                    {privateKey && (<p className="mt-4">The private key of the currently connected address is: <b>{privateKey}</b>.<br />Use this to use your address in any compatible application!</p>)}
                  </div>

                  <div>

                    {isNotPrimary && (

                      <Button
                        className="btn btn-primary m-1"
                        onClick={handleWalletMakePrimary}
                        disabled={signIsLoading}
                      >Set the currently connected wallet as the primary one</Button>

                    )}

                    <Button
                      className="btn btn-success m-1"
                      onClick={handleWalletAddition}
                      disabled={signIsLoading || userDetails?.wallets?.some(w => w.address === address)}
                    >
                      {userDetails?.wallets?.some(w => w.address === address) ? (<>Connect another wallet to be able to add it</>) : (<>Add the currently connected wallet</>)}
                    </Button>

                    {userDetails?.wallets?.some(w => w.address === address) && (

                      <Button
                        className="btn btn-danger m-1"
                        onClick={handleWalletRemoval}
                        disabled={signIsLoading}
                      >Remove the currently connected wallet</Button>

                    )}

                    {web3AuthInstance.status == "connected" && !privateKey && (<button onClick={getPrivateKey} className="btn btn-light m-2">Get the private key of this wallet</button>)}

                    {userDetails.wallets && userDetails.wallets.length >= 2 && (<Alert className='my-4'><small>Note: The first wallet in the list is considered to be the main one, it is the one used for Legends of Karnoa.</small></Alert>)}

                  </div>
                </>
              )}

              {userDetails && userDetails.error && (
                <div className="my-4">
                  <span className="text-danger">To use this service you must be connected to <a href="https://www.cryptocademia.com/" target='_blank'>www.cryptocademia.com</a> !<br />Please log in and refresh this page.</span>
                </div>
              )}

            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}